import React, { Component } from "react"
import { translate } from "react-translate"
import { Segment } from "semantic-ui-react"
import "./CoordonnéesDevis.css"

class CoordonnéesDevis extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let { t } = this.props

    return (
      <Segment id="divCoordonnées">
        <Segment id="nomFournisseur">
          {t("label_edition_coordonnées_nom_fournisseur")}
        </Segment>
        <Segment id="coordonnéesFournisseur">
          {t("label_edition_coordonnées_fournisseur")}
        </Segment>
        <Segment id="coordonnéesClient">
          {t("label_edition_coordonnées_client")}
        </Segment>
        <Segment id="adresseChantier">
          {t("label_edition_coordonnées_adresse_chantier")}
        </Segment>
        <Segment id="titreRéalisation">
          {t("label_edition_coordonnées_title_realisation")}
        </Segment>
      </Segment>
    )
  }
}

export default translate("ProCoordDevis")(CoordonnéesDevis)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/CoordonnéesDevis.js